<template>
  <div :class="$style.wrap">
    <div :class="$style.list">
      <div v-for="(item, index) in list" :key="index">
        <div
          v-if="item.info"
          :class="$style.game"
          @click="handlerMenu(item, index)"
        >
          <div :class="$style.left">
            <img :src="item.info.icon" />
          </div>
          <div :class="$style.right">
            <p>{{ item.info.title }}</p>
            <p>{{ item.info.sub_title }}</p>
          </div>
          <van-icon
            :class="[
              $style.arrow,
              item.ishow && gameIndex == index && $style.arrow_down
            ]"
            name="play-circle"
          />
        </div>

        <template v-if="item.ishow && gameIndex == index">
          <div>
            <div :class="$style.detail" v-if="item.info.type == 'pc'">
              <div :class="$style.operation">
                <div
                  v-for="(_item, index) in item.navMenu"
                  @click="goPath(item, _item)"
                  :key="index"
                  style="cursor: pointer;"
                >
                  <van-icon :class="$style.icon" :name="_item.icon" />
                  <p>{{ _item.name }}</p>
                </div>
              </div>
              <ul v-if="item.info.kf_email" :class="$style.email">
                <li>
                  客服邮箱：<a :href="`mailto:${item.info.kf_email}`">{{
                    item.info.kf_email
                  }}</a>
                </li>
                <li>
                  投诉地址：<a href="mailto:tousu@jzyx.com">tousu@jzyx.com</a>
                </li>
              </ul>
            </div>

            <div :class="[$style.detail, $style.qrcode]" v-else>
              <img
                v-if="item.info.wechat_qrc"
                :src="item.info.wechat_qrc"
                alt="游戏二维码"
              />
              <p>微信扫码关注，轻松找客服</p>
              <p
                v-if="item.info.wechat"
                v-clipboard:copy="item.info.wechat"
                v-clipboard:success="copy"
                v-clipboard:error="onError"
              >
                公众号：{{ item.info.wechat }}
              </p>
            </div>
          </div>
        </template>
      </div>
    </div>
    <!-- PC二维码 -->
    <van-popup :class="$style.popup_qrcode" v-model="showQrcode">
      <img :src="pcQrcodeInfo.pic" />
      <p>微信扫码关注，轻松找客服</p>
      <p
        v-clipboard:copy="pcQrcodeInfo.number"
        v-clipboard:success="copy"
        v-clipboard:error="onError"
        :class="$style.number"
      >
        公众号：{{ pcQrcodeInfo.number }}
      </p>
    </van-popup>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { csInit } from "@/http/serve";
export default {
  name: "gameHome",
  data() {
    return {
      list: [],
      pcQrcodeInfo: {},
      gameIndex: "", //游戏索引
      showQrcode: false, //显示PC二维码
      navMenu: [
        //端游菜单
        {
          name: "我的提单",
          path: this._anchor.lading.path,
          icon: "comment-circle"
        },
        { name: "我要提问", path: this._anchor.ask.path, icon: "question" },
        {
          name: "锁定账号",
          path: this._anchor.lockAccount.path,
          icon: "umbrella-circle"
        },
        {
          name: "清除密码锁",
          path: this._anchor.clearLock.path,
          icon: "expand"
        }
      ]
    };
  },
  mounted() {
    this.SetGame("");
    this.$ls.remove("active");
    window._jzGeneral.then(() => {
      this.getCsList();
    });
  },
  computed: {
    ...mapGetters(["gameList"])
  },
  methods: {
    ...mapActions(["SetGame"]),
    /**
     * @description 复制成功
     */
    copy() {
      this.$Toast("复制成功");
    },
    /**
     * @description 复制失败
     */
    onError() {
      this.$Toast("复制失败，请重试");
    },
    /**
     * @description 前往对应页面
     * @param {object} item  - 游戏信息
     * @param {object} _item  - 子菜单
     */
    goPath(item, _item) {
      if (_item.path == "") {
        this.pcQrcodeInfo = {
          pic: item.info.media.wechat,
          number: item.info.media.wechat_number
        };
        this.showQrcode = true;
        return false;
      }
      this.SetGame({
        name: item.info.title,
        id: item.game_id
      });
      this.$router.push({ path: _item.path });
    },
    /**
     * @description  获取游戏列表
     */
    async getCsList() {
      const { data, rcode } = await csInit();
      if (rcode !== 0) return;
      this.list = data.map(item => {
        const gameData = this.gameList[item.game_id] || (item.type && item);
        if (gameData) {
          return {
            ...item,
            info: gameData,
            isShow: false,
            ...(gameData.type == "pc" && { navMenu: this.navMenu })
          };
        }
        return item;
      });
    },
    /**
     * @description 展示子菜单
     * @param {object} item  - 游戏信息
     * @param {number} index - 索引
     */
    handlerMenu(item, index) {
      this.gameIndex = index;
      this.list.map((item, _index) => {
        this.gameIndex == _index
          ? item.isShow
            ? (item.isShow = false)
            : (item.isShow = true)
          : (item.isShow = false);
        return item;
      });
      this.$set(item, "ishow", item.isShow);
    }
  }
};
</script>

<style lang="less" module>
.wrap {
  padding: 1.7rem 0.46rem 1rem 0.46rem;
}
.list {
  .size(100%);
  & > div {
    margin-bottom: 0.36rem;
  }
}
.popup_qrcode {
  .flex-col;
  .flex-align-center;
  background: transparent;
  img {
    .size(5rem);
    margin-bottom: 0.3rem;
  }
  p {
    color: #fff;
    font-size: 0.26rem;
  }
  .number {
    padding: 0.15rem;
  }
}
.game {
  .size(100%, 1.56rem);
  .flex-align-center;
  background-color: #ffffff;
  box-shadow: 0rem 0.09rem 0.16rem 0rem rgba(14, 5, 10, 0.06);
  border-radius: 0.1rem;
  cursor: pointer;
}
.arrow {
  font-size: 0.45rem;
  color: rgb(72, 213, 175);
  &_down {
    transform: rotate(90deg);
  }
}

.left {
  .size(2rem, 100%);
  .flex-center;

  img {
    .size(1rem);
    object-fit: contain;
  }
}
.right {
  .size(3.5rem, auto);
  p:first-child {
    font-size: 0.3rem;
    color: #222222;
  }
  p:last-child {
    margin-top: 0.13rem;
    font-size: 0.25rem;
    color: #ababab;
  }
}
.detail {
  .size(100%, auto);
  padding: 0.25rem 0;
  background-image: linear-gradient(70deg, #48d5af 0%, #82e0d2 100%),
    linear-gradient(#48d5af, #48d5af);
  background-blend-mode: normal, normal;
}
.operation {
  .size(100%);
  .flex-wrap;

  justify-content: space-around;
  padding-top: 0.2rem;

  & > div {
    .flex-col;

    align-items: center;
    height: 1.3rem;
    border-radius: 0.15rem;
    color: #fffefe;
    .icon {
      font-size: 0.45rem;
      margin-bottom: 0.15rem;
    }
  }
}
.qrcode {
  .flex-center;
  .flex-col;
  img {
    .size(2rem);
    display: block;
  }
  p {
    margin-top: 0.1rem;
    font-size: 0.25rem;
    color: #ffffff;
  }
  .hidden {
    transform: rotate(180deg);
  }
}

.email {
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin: 0 0.3rem;
  padding: 0.1rem 0;
  background-color: fade(#fff, 20%);
  border-radius: 0.05rem;
  color: #fff;

  a {
    color: inherit;
  }
}
</style>
